/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Action from './Action/index'
import Icon from './Icon/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let treatmentCardTxsTreatmentPlanActionValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
format: fromHelpers.getHeader,
})
let treatmentCardTxsTreatmentPlanActionValueData1 = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
})
let treatmentCardCaseCloserRequestValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'case_closer_request',
})
let aggregateData = fromHelpers.getDescription(treatmentCardTxsTreatmentPlanActionValueData1, treatmentCardCaseCloserRequestValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral200,'--bblr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-6-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-7-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-11-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Icon
  viewPath={`${viewPath}/Icon`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 data="treatment_card.txs.treatment_plan_action"
 format="helpers.js getHeader"
 text={treatmentCardTxsTreatmentPlanActionValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 wordBreak="break-word"
 marginTop={dtSpaceXxs}
 marginBottom={dtSpaceXs}
 color={dtColorsNeutral500}
 data="treatment_card.txs.treatment_plan_action"
 data="treatment_card.case_closer_request"
 aggregate="helpers.js getDescription"
 text={aggregateData}
/>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
</div>
{children}
</React.Fragment>)
}